import React, { useState } from 'react';
import {
    PortfolioItemWrapper,
    PortfolioItemSelectedCircle,
    RolesNameIconWrapper,
    NameAndInfo,
    NameText,
    MoreInfo,
} from './portfolios.styles';
import { permissionsTexts } from '../Roles/RoleRow';
export const PortfolioListItem = ({
    portfolio,
    ownerInfo,
    isSelected,
    onClick,
    isB2BUser,
    cIndex,
}) => {
    const isOwnerItem = !!ownerInfo;
    const [isHovered, setIsHovered] = useState(false);
    const name = isOwnerItem ? ownerInfo.fullName : portfolio.name;
    const roleText = isOwnerItem ? 'Owner' : permissionsTexts[portfolio.role];
    const roleDescription = isOwnerItem ? 'Personal portfolio' : portfolio.roleDescription;
    const iconLetter = isOwnerItem ? ownerInfo.firstNameFirstLetter : portfolio.name.charAt(0).toUpperCase();

    return (
        <PortfolioItemWrapper onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} isSelected={isSelected} onClick={onClick} isB2BUser={isB2BUser}>
            {!isB2BUser && <PortfolioItemSelectedCircle isSelected={isSelected} />}
            <RolesNameIconWrapper
                isB2BUser={isB2BUser && !isOwnerItem}
                isOwner={isOwnerItem || (portfolio && portfolio.isOwner)}
                color={!isOwnerItem && portfolio ? portfolio.color : undefined}
                cIndex={!isOwnerItem ? cIndex : undefined}
            >
                {iconLetter}
            </RolesNameIconWrapper>
            <NameAndInfo>
                <NameText>{name}</NameText>
                <MoreInfo>{`${roleDescription} · ${roleText}`}</MoreInfo>
            </NameAndInfo>
            {isB2BUser && isHovered && <div style={{ display: 'flex', marginLeft: 'auto' }}><ArrowRightIcon /></div>}
        </PortfolioItemWrapper>
    );
};

const ArrowRightIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 12L6 12M18 12L13 6M18 12L13 18" stroke="black" strokeWidth="1.5" />
        </svg>
    )
}